import React from "react";
import CormoSchema from "../helpers/schemas/cormo-schema";

export default function SEO({ metaTitle, metaDescription, lang, metaKeywords, ogTitle, ogImage, ogDescription }) {
  metaDescription ??=
    "Pomagamy firmom rosnąć, łącząc nowoczesne technologie z realnymi rozwiązaniami, które usprawniają procesy, zwiększają efektywność i otwierają nowe możliwości rozwoju w cyfrowym świecie.";
  return (
    <>
      <html lang={lang} />
      <meta charSet="utf-8" />
      <title>{metaTitle ?? "Cormo Software House"}</title>
      <CormoSchema metaDescription={metaDescription} />
      <meta name="description" content={metaDescription} />
      <meta property="og:title" content={ogTitle ?? "Cormo Software House"} />
      <meta property="og:image" content={ogImage ?? ''} />
      <meta property="og:description" content={ogDescription ?? metaDescription ?? ''} />
      <meta name="twitter:description" content={ogDescription ?? metaDescription ?? ''} />
      <meta name="twitter:title" content={ogTitle ?? "Cormo Software House"} />
      <meta name="twitter:image" content={ogImage ?? ''} />
      <meta property="og:type" content="website" />
      {metaKeywords && <meta name="keywords" content={metaKeywords} />}
      <meta name="theme-color" content="#fff"/>
    </>
  );
}
